<template>
  <fragment>
    <default-header :h2="$t('passwordReset.title')"></default-header>
    <back-btn></back-btn>
    <div class="innerContent noBottomPadding noSpaceBetween pl-1 pr-1">
      <img class="login-tester" src="@/assets/ebt965p.png" alt="Exide EBT-965P" />
      <div>
        <div
          v-if="this.message"
          class="alert"
          :class="'alert-'+this.message.status"
        >{{ this.message.text }}</div>

        <form @submit.prevent="submit" v-if="!sent">
          <div class="form-group small-label mb-1">
            <input
              type="email"
              class="form-control"
              id="recovery-email"
              :placeholder="$t('general.enterEmail')"
              v-model="email"
              v-validate="'required|email'"
              :data-vv-as="$t('general.enterEmail')"
              name="recovery-email"
            />
            <label v-show="email" for="recovery-email">{{$t('passwordReset.emailAdress')}}</label>
            <span
              v-if="errors.first('recovery-email')"
              class="vv-error text-center d-block mt-2 mb-2"
            >{{ $t('general.invalidEmail') }}</span>
          </div>
          <span class="desc small text-center">{{$t('passwordReset.emailInbox')}}</span>
          <button type="submit" class="btn btn-primary btn-block mt-4 mb-2">{{$t('general.send')}}</button>
        </form>
        <router-link
          to="/login"
          class="pl-1 pr-1 btn btn-primary btn-block mt-2 mb-4"
        >{{$t('general.login')}}</router-link>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DefaultHeader from '@/partials/DefaultHeader';
import { HTTP } from '../http';
import BackBtn from '../components/BackBtn';

export default {
  name: 'PasswordReset',
  components: {
    DefaultHeader,
    BackBtn
  },
  data() {
    return {
      email: '',
      sent: false
    };
  },
  beforeMount() {
    this.setMessage({
      status: null,
      text: null
    });
  },
  beforeDestroy() {
    this.setMessage({
      status: null,
      text: null
    });
  },
  methods: {
    ...mapActions(['setMessage']),
    submit() {
      this.$validator.validate().then(valid => {
        if (!valid) {
          return;
        }

        HTTP.post('/api/users/password-reset', {
          email: this.email
        })
          .then(response => {
            this.setMessage({
              status: response.data.error ? 'danger' : 'success',
              text: response.data.message
            });
            this.sent = !response.data.error;
          })
          .catch(() => {
            this.setMessage({
              status: 'danger',
              text: 'Something went wrong while sending password recovery request.'
            });
          });
      });
    }
  },
  computed: {
    ...mapGetters({
      message: 'getMessage'
    })
  }
};
</script>

<style>
.login-tester {
  display: block;
  margin: 0 auto;
  max-width: 60%;
}

.desc {
  color: #373a36;
  display: block;
  font-size: 0.7em;
}
</style>
